export default __webpack_public_path__ + "static/media/poster-2.92db59a8.png";